//= ===============================================================================================
//
//  #####     #####   ##   ##  ######  #####         ####    ##   ##    ###    #####    ####
//  ##  ##   ##   ##  ##   ##    ##    ##           ##       ##   ##   ## ##   ##  ##   ##  ##
//  #####    ##   ##  ##   ##    ##    #####        ##  ###  ##   ##  ##   ##  #####    ##  ##
//  ##  ##   ##   ##  ##   ##    ##    ##           ##   ##  ##   ##  #######  ##  ##   ##  ##
//  ##   ##   #####    #####     ##    #####         ####     #####   ##   ##  ##   ##  ####
//
//= ===============================================================================================

import _ from 'lodash'
import { boot } from 'quasar/wrappers'
import { useAuthStore } from 'src/stores'
import { checkVersion } from 'src/common/helpers/functions/checkVersion'
import useAccess from 'src/hook/useAccess'
import { catchError } from 'src/common/helpers/generator/error.helper'
import { service } from 'boot/service'

const store = useAuthStore()
const { canPassAccess } = useAccess()

/* -------------------------------------------------------------------------- */
/*                                Get/Set Role                                */
/* -------------------------------------------------------------------------- */
if (store.hasToken) {
  service.role
    .getRoles({ id: store.portalUser.role_id })
    .then((result) => {
      store.setRole(result.data.list[0])
    })
    .catch((err) => {
      const errors = catchError(err)
      if (typeof errors === 'object' && Array.isArray(errors)) {
        for (const error of errors) console.error(error)
      } else console.error(errors)
    })
}

export default boot(({ router /*, ssrContext */ }) => {
  /* -------------------------------------------------------------------------- */
  /*                     START: Check token and permissions                     */
  /* -------------------------------------------------------------------------- */
  router.beforeEach(async (to, from, next) => {
    /** @type {number[]} */
    const routeAccesses = to?.meta?.access

    const hasPageAccess = canPassAccess(routeAccesses)
    const unRegisteredPages = ['Activation', 'Login', 'Forgotten', 'ForgottenVerify', 'ResetPassword']
    const publicPages = ['Entrance', 'SignUp', 'SecuritySetup', 'DigitalMenuLogin']
    const isInUnRegisteredPages = unRegisteredPages.includes(to.name)
    const isInPublicPages = publicPages.includes(to.name)

    await checkVersion()

    // ──────────────────────────────────────────────────────────────────────
    //   :::::: C O N D I T I O N S : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────────
    navigationCondition(routeAccesses, hasPageAccess, isInPublicPages, next, isInUnRegisteredPages, store)
  })
})

function navigationCondition(routeAccesses, hasPageAccess, isInPublicPages, next, isInUnRegisteredPages, storeParam) {
  if (routeAccesses?.length && !hasPageAccess) next(false)
  else if (isInPublicPages) next()
  else if (isInUnRegisteredPages && storeParam.hasToken) {
    next({ name: 'Dashboard' })
  } else if (!isInUnRegisteredPages && !storeParam.hasToken) {
    next({ name: 'Login' })
  } else next()
}
